import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Input, input } from '@angular/core';
import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullOrUndefined } from 'util';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BCMCLPUser, TeamCodes } from '../../../models/clpuser.model';
import { CMClub, CMClubResponse, CMSite, CMSiteListResponse } from '../../../models/cm-club-service.model';
import { UserDD } from '../../../models/generic-response.model';
import { MemCaseItem, MemCaseListRequest, MemCaseResponse, MemPause, MemPauseListRequest, MemPauseResponse, REF_MemCaseConcernLevel, REF_MemCaseOrigin, REF_MemCaseReason, REF_MemCaseStatus } from '../../../models/membership.model';
import { CMClubService } from '../../../services/cm-club.service';
import { MembershipService } from '../../../services/membership.service';
import { NotificationService } from '../../../services/notification.service';
import { GlobalService } from '../../../services/shared/global.service';
import { LocalService } from '../../../services/shared/local.service';
import { UtilityService } from '../../../services/shared/utility.service';
import { TeamOfficeService } from '../../../services/team-office.service';
import { UserService } from '../../../services/user.service';

declare var $: any;

@Component({
    selector: 'app-mem-case-list',
    templateUrl: './mem-case-list.component.html',
    styleUrls: ['./mem-case-list.component.css']
})
/** mem-case-list component*/
export class MemCaseListComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: MatTableDataSource<MemCaseItem>;
    displayedColumns: string[] = ['contactName','caseNumber', 'subject', 'dtOpened', 'dtClosed', 'caseReason', 'caseResolution', 'caseStatus'];
    encryptedUser: string;
    cases: MemCaseItem[];
    memCaseListRequest = {} as MemCaseListRequest;
    user: BCMCLPUser;
    clpCompanyId: number;
    siteId: number;
    sites: number[];
    users: number[];
    class4Code: any;
    curTeam: TeamCodes = <TeamCodes>{};
    clubConfig: CMClub;
    @Input() isContact: boolean = false;
    @Input() contactId: number = 0;
    selectedCMSiteID: number = 0;
    clpUsersDD: UserDD[];
    selectedUserID: number = 0;
    caseStatusID: number = 0;
    caseConcernID: number = 0;

    createDateFilters = [
        {
            "value": 1,
            "name": "This Month"
        },
        {
            "value": 2,
            "name": "Last Month"
        },
        {
            "value": 3,
            "name": "Custom"
        }
    ]
    customFilter: boolean = false;
    customDateStr: string = '';
    selectedCtDtFilterName: string;
    selectedCtDtFilter: number = 1;
    currentRange = new FormGroup({
        start: new FormControl<Date | null>(null),
        end: new FormControl<Date | null>(null),
    });
    selectedCustomdtStart: string;
    selectedCustomdtEnd: string;
    cmSites: CMSite[];
    ref_MemCaseStatus_List: REF_MemCaseStatus[];
    ref_MemCaseConcernLevel_List: REF_MemCaseConcernLevel[];
    ref_MemCaseOrigin_List: REF_MemCaseOrigin[];
    ref_MemCaseReason_List: REF_MemCaseReason[];
    caseOriginID: number = 0;
    caseReasonID: number = 0;
    teamSub: Subscription;
    showCaseModal: boolean;
    selectedCaseID: number = 0;
    private destroy$ = new Subject<void>();

    constructor(private localService: LocalService,
        private userService: UserService,
        private _utilityService: UtilityService,
        private clubService: CMClubService,
        private _membershipService: MembershipService,
        private _notifyService: NotificationService,
        private _globalService: GlobalService,
        private _router: Router,
        private datePipe: DatePipe,
        private _teamOfficeService: TeamOfficeService,
        private route: ActivatedRoute,
    ) {
        this.localService.setIsContract(false);
        this.localService.setShowMenu(true);
        this.localService.setIsMembership(true);
        this.localService.updateTeamDD(true)
        this.localService.setRouteName("mem-case-list");
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }

    ngAfterViewInit() {
        if (this.contactId > 0) {
            this.displayedColumns = ['caseNumber', 'subject', 'dtOpened', 'dtClosed', 'caseReason', 'caseStatus'];
        }
        this.sites = [];
        this.encryptedUser = localStorage.getItem("token");
        this.siteId = this.route.snapshot.queryParams.siteId;
        this.class4Code = this.route.snapshot.queryParams.c4Code;
        if (this.encryptedUser) {
            this.authenticateR().then(() => {
                if (this.user) {
                    this.loadData();
                }
                else {
                    this._router.navigate(['/unauthorized']);
                }
            });
        }
        else {
            this._router.navigate(['/unauthorized']);
        }
    }

    ngOnInit() {
       
        //this.getMembershipList();
    }

    private async authenticateR() {

        await this.localService.authenticateUser(this.encryptedUser)
            .then(async (result: BCMCLPUser) => {
                if (result) {
                    this.user = UtilityService.clone(result);
                    this.clpCompanyId = this.user?.cLPCompanyID

                }
            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("navMenu.authenticateR", err.message, null);
                this._utilityService.handleErrorResponse(err);
            });
    }

    getDate(value) {
        if (value == '0001-01-01T00:00:00') {
            return '';
        }
        else
            return value;
    }

    async siteSearch() {
        if (this.clubConfig?.clubId > 0) {
            await this.clubService.siteSearch(this.encryptedUser, 0, this.clubConfig?.clubId, 0, 0).
                then(async (result: CMSiteListResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.cmSites = response?.sites;
                    }
                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async loadData() {
        this.teamSub = this._teamOfficeService.curTeam.pipe(takeUntil(this.destroy$)).subscribe(async (data: any) => {
            if (data != 0 && data != null) {
                this.curTeam = data
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.ref_MemCaseStatus_List = this.localService.refMem_GetAllResponse.ref_MemCaseStatus_List;
                    this.ref_MemCaseConcernLevel_List = this.localService.refMem_GetAllResponse.ref_MemCaseConcernLevel_List;
                    this.ref_MemCaseReason_List = this.localService.refMem_GetAllResponse.ref_MemCaseReason_List;
                    this.ref_MemCaseOrigin_List = this.localService.refMem_GetAllResponse.ref_MemCaseOrigin_List;
                    this.memCase_GetList();
                }
            }
            else {
                this.curTeam = JSON.parse(localStorage.getItem("curTeam") || "{}")
                if (this.curTeam?.teamCode > 0) {
                    await this.CMClub_Get();
                    await this.siteSearch();
                    await this.cLPUserGetListByTeamCode(this.user?.cLPCompanyID, this.curTeam?.teamCode);
                    this.ref_MemCaseStatus_List = this.localService.refMem_GetAllResponse.ref_MemCaseStatus_List;
                    this.ref_MemCaseConcernLevel_List = this.localService.refMem_GetAllResponse.ref_MemCaseConcernLevel_List;
                    this.ref_MemCaseReason_List = this.localService.refMem_GetAllResponse.ref_MemCaseReason_List;
                    this.ref_MemCaseOrigin_List = this.localService.refMem_GetAllResponse.ref_MemCaseOrigin_List;
                    this.memCase_GetList();

                }
            }
        })
    }


    async CMClub_Get() {
        if (this.curTeam?.teamCode > 0) {
            await this.clubService.CMClub_Get(this.encryptedUser, this.clpCompanyId, this.curTeam?.teamCode).
                then(async (result: CMClubResponse) => {
                    if (result) {
                        let response = UtilityService.clone(result);
                        this.clubConfig = response?.clubConfig
                    }

                })
                .catch((err: HttpErrorResponse) => {
                    this._globalService.error("site-fields.clubConfigGet", err.message, null,
                    );
                    this._utilityService.handleErrorResponse(err);
                });
        }
    }

    async memCase_GetList() {
        this.memCaseListRequest.clubId = this.clubConfig?.clubId;
        this.memCaseListRequest.contactId = this.contactId;
        this.memCaseListRequest.sites = this.sites;
        this.memCaseListRequest.users = this.users;
        this.memCaseListRequest.caseOrigin = this.caseOriginID;
        this.memCaseListRequest.caseReason = this.caseReasonID;
        this.memCaseListRequest.caseStatus = this.caseStatusID;
        this.memCaseListRequest.dateType = 1;
        this.memCaseListRequest.timeFrame = this.selectedCtDtFilter;
        this.memCaseListRequest.strdtEnd = this.selectedCustomdtEnd;
        this.memCaseListRequest.strdtStart = this.selectedCustomdtStart;
        this.memCaseListRequest.memberConcernLevel = this.caseConcernID;
        await this._membershipService.memCase_GetList(this.encryptedUser, this.memCaseListRequest, this.user?.cLPUserID).
            then(async (result: MemCaseResponse) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.cases = response?.cases;
                    this.dataSource = new MatTableDataSource(this.cases);
                    this.addTimeout(() => {
                        this.dataSource.paginator = this.paginator;
                    }, 1000)
                    this.dataSource.sort = this.sort;

                    this.dataSource.sortingDataAccessor = (item: MemCaseItem, property: string): any => {
                        //switch (property) {
                        //    case 'dtCreated':
                        //    case 'dtContractStart':
                        //    case 'dtContractEnd':
                        //    case 'dtPaymentBegins':
                        //        return new Date(item[property]);
                        //    case 'dteSig':
                        //        return new Date(this.getDate(item.dtCreated));
                        //    default:
                        //        return typeof item[property] === 'string'
                        //            ? item[property].toLowerCase()
                        //            : item[property];
                        //}
                    };


                    //this.dataSource.filterPredicate =
                    //    (data: CMContractItem, filter: string) => {
                    //        let values = filter.split(' ');

                    //        let finalValues: boolean[] = [];
                    //        let final: boolean = true;

                    //        values.forEach((value) => {
                    //            finalValues.push(data.cmContractID.toString().indexOf(value) != -1 ||
                    //                data.contactName.trim().toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtCreated).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtContractEnd).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtContractStart).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dteSig).toLowerCase().indexOf(value) != -1 ||
                    //                this.formatDate(data.dtPaymentBegins).toLowerCase().indexOf(value) != -1 ||
                    //                data.fees.trim().toLowerCase().indexOf(value) != -1 ||
                    //                this.formatMems(data.Members).trim().toLowerCase().indexOf(value) != -1 ||
                    //                data.siteName.trim().toLowerCase().indexOf(value) != -1 ||
                    //                data.status.trim().toLowerCase().indexOf(value) != -1
                    //            );
                    //        });

                    //        //only return if all values are true
                    //        finalValues.forEach(f => {
                    //            if (!f)
                    //                final = false;
                    //        });

                    //        return final;
                    //    };
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("cm-contract-list.cMContractGetList", err.message, null,
                    'clpCompanyId: ' + this.clpCompanyId
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    formatDate(dateString) {
        if (dateString != '' && !isNullOrUndefined(dateString)) {
            const date = new Date(dateString);
            //const formattedDate = `${date.getUTCMonth() + 1}/${date.getUTCDate()}/${date.getUTCFullYear()}`;
            const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
            return formattedDate;
        }
        else return '';
    }

    async onChangeUserDD() {
        if (this.selectedUserID > 0) {
            this.users = [];
            this.users.push(this.selectedUserID);
            await this.memCase_GetList();
        }
        else {
            this.users = [];
            await this.memCase_GetList();
        }
    }

    async onChangeCMSite() {
        if (this.selectedCMSiteID > 0) {
            this.sites = [];
            this.sites.push(this.selectedCMSiteID);
            await this.memCase_GetList();
        } else {
            this.sites = [];
            await this.memCase_GetList();
        }
    }

    async onChangeStatus() {
        await this.memCase_GetList();
    }

    async onChangeCaseConcern() {
        await this.memCase_GetList();
    }

    async onChangeCaseReason() {
        await this.memCase_GetList();
    }

    async onChangeCaseOrigin() {
        await this.memCase_GetList();
    }
    async createDtFilterChange() {
        let value = this.selectedCtDtFilter;

        if (value != 3) {
            this.selectedCtDtFilter = +value;
            await this.memCase_GetList();
        }
        else {
            this.customDateStr = ''
            this.customFilter = true;
        }
    }

    revertCustomFinalizeddtFilter() {
        this.customFilter = false;
        this.selectedCtDtFilter = 1;
        this.selectedCtDtFilterName = "This Month";
        this.currentRange = new FormGroup({
            start: new FormControl<Date | null>(null),
            end: new FormControl<Date | null>(null),
        });
        this.memCase_GetList();
    }


    dateRangeChange(dateRangeStart: HTMLInputElement, dateRangeEnd: HTMLInputElement) {
        var startDt = dateRangeStart.value;
        var endDt = dateRangeEnd.value;
        if (startDt) {
            let customdtStart = this.datePipe.transform(startDt, 'MMddyyyy');
            this.selectedCustomdtStart = customdtStart;

        }
        if (endDt) {
            let customdtEnd = this.datePipe.transform(endDt, 'MMddyyyy');
            this.selectedCustomdtEnd = customdtEnd;
            //this.selectedCtDtFilter = 3;
            this.selectedCtDtFilterName = "Custom"
            if (this.selectedCustomdtStart && this.selectedCustomdtEnd != null) {
                this.memCase_GetList();
            }
        }
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim().toLowerCase();
        if (this.dataSource) {
            this.dataSource.filter = filterValue;
        }
    }

    async cLPUserGetListByTeamCode(clpCompanyId, teamCode) {
        await this.userService.cLPUserGetListByTeamCode(this.encryptedUser, clpCompanyId, teamCode ? teamCode : this.user?.cLPUserID).
            then(async (result: UserDD[]) => {
                if (result) {
                    let response = UtilityService.clone(result);
                    this.clpUsersDD = response
                    this.clpUsersDD.unshift({
                        value: 0,
                        text: "--ALL--"
                    })
                }

            })
            .catch((err: HttpErrorResponse) => {
                this._globalService.error("contact-task.getLoadUsers", err.message, null,
                );
                this._utilityService.handleErrorResponse(err);
            });
    }

    selectRow(row: any): void {
        if (!row?.caseID) return;
        this.selectedCaseID = row?.caseID;
        if (this.isContact) {
            this.showCaseModal = true;
            $('#showCaseModal').modal('show');
            return;
        }

        const url = `/mem-case?caseID=${row.caseID}`;
        window.open(url, '_blank');
    }

    hideShowCaseModal(isCloseButtonClicked: boolean) {
        if (isCloseButtonClicked) {
            this.memCase_GetList();
            this.showCaseModal = false;
            $('#showCaseModal').modal('hide');
        }
    }
    navToMemContact(contactID) {
        let url = 'mem-contact/' + contactID;
        window.open(url, '_blank');
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

}
